import React, { useState, useEffect } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import styles from '../../styles/forms/edit_substage_wizard/EditSubstageForm.scss';
import Button from '../../components/Button';
import Select from '../../components/Select';
import Input from '../../components/Input';
import { __, mapStateToProps, setTableParams } from '../../core/utils';
import { withRouter } from 'react-router';
import ButtonGroup from '../../components/ButtonGroup';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import * as _ from 'lodash';
import { listPossibleStages } from '../../redux/actions/table/substages';
import DateTimePicker from '../../components/DateTimePicker';
import Tooltip from '../../components/Tooltip';
import ArrowDownSmallIcon from '../../assets/images/arrow-down-small-15x15.svg';
import Checkbox from '../../components/Checkbox';
import classNames from 'classnames';

const EditSubstageForm = ({
  localization,
  handleSubmit,
  onSubmit,
  submitting,
  application_language_id,
  match,
  initialValues,
}) => {
  const [possibleStages, setPossibleStages] = useState([]);

  const _handleSubmit = (create_and_edit) => {
    return handleSubmit((formData) => {
      return onSubmit({
        ...formData,
        edit: create_and_edit,
      });
    })();
  };

  const application_languages = _.transform(
    _.filter(
      localization.languages,
      (language) => language.application_language == true
    ),
    (languages, language) => {
      languages[language.id] = language.id == application_language_id;
      return languages;
    },
    {}
  );

  useEffect(() => {
    const project_id = match.params.project;

    listPossibleStages(project_id).then(({ response }) => {
      setPossibleStages(response.data);
    });
  }, []);

  // const statuses = [
  //   { label: __('substage.status.started'), value: '0', color: '#5777FC' },
  //   { label: __('substage.status.finished'), value: '1', color: '#ADD42B' },
  // ];

  const stage_statuses = [
    {
      value: 'not-started',
      label: __('stages.status.not-started'),
      color: '#9C27B0',
    },
    {
      value: 'started',
      label: __('stages.status.started'),
      color: '#5777FC',
    },
    {
      value: 'finished',
      label: __('stages.status.finished'),
      color: '#ADD42B',
    },
    {
      value: 'closed',
      label: __('stages.status.closed'),
      color: '#009688',
    },
    {
      value: 'reopened',
      label: __('stages.status.reopened'),
      color: '#303F9F',
    },
    {
      value: 'canceled',
      label: __('stages.status.canceled'),
      color: '#CCCDD1',
    },
  ];

  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='status'
              component={Select}
              label={__('substage.status')}
              options={stage_statuses}
              noSort
              dropdown
              wrapper={(handleOpen, activeItem, elementRef) => (
                <Tooltip text={__('substage.status')}>
                  <div
                    className={styles.dropdown}
                    ref={elementRef}
                    style={{ background: activeItem.color }}
                    onClick={handleOpen}
                  >
                    <div className={styles.button}>
                      {activeItem.label}
                      <ArrowDownSmallIcon />
                    </div>
                  </div>
                </Tooltip>
              )}
            />
          </div>
          <div className={styles.f1} />
        </div>

        <Field
          name='name'
          // localized={application_languages}
          localized={initialValues.projectLanguages}
          component={Input}
          label={__('substage.name')}
        />
        <Field
          name='description'
          component={Input}
          label={__('substage.description')}
          // localized={application_languages}
          localized={initialValues.projectLanguages}
        />
        {/* <div className={styles.flex}>
          <div className={styles.f3}>
            <Field
              name='date'
              component={DateTimePicker}
              label={__('substage.date')}
              footer
              range
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='duration'
              component={Input}
              label={__('substage.duration')}
            />
          </div>
        </div> */}
        <div className={styles.flex}>
          <div className={classNames(styles.date, styles.date)}>
            <Field
              // disabled={!this.props.isProjectAdministrator}
              name='date'
              component={DateTimePicker}
              label={__('substage.date-range')}
              footer
              range
            />
          </div>
          {/* <div className={classNames(styles.f1, styles.duration)}>
            <Field
              name='date.duration'
              component={Input}
              label={__('substage.duration')}
              placeholder={__('substage.enter-duration')}
              // disabled={isDeadline || disabled}
            />
          </div> */}
          <div className={classNames(styles.f1, styles.deadline)}>
            <div className={styles.deadlineLabel}>
              {__('substage.deadline')}
            </div>
            <Field
              name='date.deadline'
              component={Checkbox}
              // label={__('deadline')}
              className={styles.checkbox}
              onChange={(event) => {}}
              // disabled={disabled}
            />{' '}
          </div>
          <div className={classNames(styles.f2, styles.estimate)}>
            <Field
              name='time_log.planned_time'
              component={Input}
              label={__('substage.planned-time')}
              placeholder={__('substage.enter-planned-time')}
              // disabled={disabled}
            />
          </div>
        </div>
        <Field
          name='stage_id'
          component={Select}
          label={__('substage.stage')}
          options={possibleStages}
        />
      </div>
      <div className={styles.footer}>
        <Button
          lightGray
          medium
          left
          middleText={__('button.cancel')}
          onClick={() =>
            setTableParams('substages', {
              edit_substage_wizard: undefined,
            })
          }
        />
        <ButtonGroup>
          <Button
            lightBlue
            medium
            middleText={__('button.edit')}
            spinning={submitting}
            onClick={() => _handleSubmit(false)}
          />
        </ButtonGroup>
      </div>
    </Form>
  );
};

export default withRouter(
  reduxForm({ form: 'edit_substage_wizard.edit_substage' })(
    subscribe(
      Localization,
      'localization'
    )(
      mapStateToProps((state) => ({
        application_language_id: state.auth.language_id,
      }))(EditSubstageForm)
    )
  )
);
